import { application } from "./application";

import { AvatarFieldController } from "./form_helpers/avatar_field_controller";
import { CheckoutFormController } from "./payment/checkout_form_controller";
import { DatePickerFormController } from "./form_helpers/date_picker_form_controller";
import { NoEmailController } from "./form_helpers/no_email_controller";
import { LeadScanGridController } from "./grids/lead_scan_grid_controller";
import { ReadOnlyGridController } from "./grids/read_only_grid_controller";
import { RegFormController } from "./form_helpers/reg_form_controller";
import { RoomingFieldController } from "./rooming/rooming_field_controller";
import { SegmentLogoutLinkController } from "~/controllers/analytics/segment_logout_link_controller";
import { SegmentResetUserFormController } from "~/controllers/analytics/segment_reset_user_form_controller";
import { SquareCheckoutFormController } from "./payment/square_checkout_form_controller";

application.register("avatar-field", AvatarFieldController);
application.register("checkout-form", CheckoutFormController);
application.register("date-picker-form", DatePickerFormController);
application.register("lead-scan-grid", LeadScanGridController);
application.register("no-email", NoEmailController);
application.register("read-only-grid", ReadOnlyGridController);
application.register("reg-form", RegFormController);
application.register("rooming-field", RoomingFieldController);
application.register("segment-logout-link", SegmentLogoutLinkController);
application.register("segment-reset-user-form", SegmentResetUserFormController);
application.register("square-checkout-form", SquareCheckoutFormController);
